import {
  InfoOutlined,
  LockReset,
  ManageAccounts,
  WhatsApp,
  ShoppingCartCheckout,
  PlayCircleOutline,
  GroupsOutlined,
  AddCardOutlined,
  PublishedWithChangesOutlined,
  PersonAddAltOutlined,
  ImportExport,
  LocalLibrary,
  ReceiptOutlined,
  ResetTv,
} from "@mui/icons-material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { request } from "../request";
import Password from "./Password";
import Summary from "./StoreSummary";
import Reset from "./Reset";
import { openSnack, snackMessage, Load } from "../redux/GlobalStates";
import { Link, useNavigate } from "react-router-dom";
import EditStoreInfo from "./EditStoreInfo";
export default function Footer() {
  const navigate = useNavigate();
  const storeId = localStorage.getItem("storeId");
  const store = useSelector((state) => state.store.Store);
  const dispatch = useDispatch();
  const [openPass, setOpenPass] = useState(false);
  const [openEditStoreInfo, setOpenEditStoreInfo] = useState(false);
  const [openSum, setOpenSum] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const noPrivy = () => {
    window.alert("You don't have the privilege to perform this action");
  };
  const handleReset = async () => {
    dispatch(Load());
    if (!oldPassword || !password || !password2) {
      dispatch(snackMessage("Provide data for all fields"));
    } else if (password !== password2) {
      dispatch(snackMessage("Passwords do not match"));
    } else {
      try {
        const res = await request.put(`/store/password/reset?id=${storeId}`, {
          password,
          oldPassword,
        });
        dispatch(snackMessage(res.data));
      } catch (err) {
        dispatch(snackMessage(err.response.data));
      }
    }
    setOpenPass(false);
    dispatch(openSnack());
    dispatch(Load());
  };
  return (
    <div className="footer">
      <EditStoreInfo
        open={openEditStoreInfo}
        handleClose={() => setOpenEditStoreInfo(false)}
      />

      <Password
        open={openPass}
        close={() => setOpenPass(false)}
        reset={() => handleReset()}
        closeAlert={() => setOpenAlert(false)}
        openAlert={openAlert}
        oldEvent={(e) => setOldPassword(e.target.value)}
        newEvent={(e) => setPassword(e.target.value)}
        confirmEvent={(e) => setPassword2(e.target.value)}
      />
      <Reset
        open={openResetDialog}
        handleClose={() => setOpenResetDialog(false)}
      />
      <Summary open={openSum} close={() => setOpenSum(false)} />
      <div className="footer-items">
        <a href="https://wa.me/233553385436" className="footer-links">
          <WhatsApp /> Contact
        </a>
        <li
          className="footer-links"
          onClick={() => {
            store.mode !== "Admin"
              ? alert("You don't have such privilege")
              : setOpenPass(true);
          }}
        >
          <LockReset />
          Reset Password
        </li>
        <li
          className="footer-links"
          onClick={() => {
            store.mode !== "Admin"
              ? alert("You don't have such privilege")
              : setOpenEditStoreInfo(true);
          }}
        >
          <PublishedWithChangesOutlined />
          Edit Store Info
        </li>
        <li
          className="footer-links"
          onClick={
            store.attendant?.see_sales_details || store.mode === "Admin"
              ? () => setOpenSum(true)
              : noPrivy
          }
        >
          <InfoOutlined /> Summary
        </li>
        <li to="/tuts" className="footer-links">
          <LocalLibrary /> Tutorials
        </li>
        <li
          className="footer-links"
          onClick={
            store.attendant?.see_sales_details || store.mode === "Admin"
              ? () => navigate("/highlights")
              : noPrivy
          }
        >
          <PlayCircleOutline /> Highlights
        </li>
        <li
          className="footer-links"
          onClick={
            store.attendant?.see_sales_details || store.mode === "Admin"
              ? () => navigate("/customers")
              : noPrivy
          }
        >
          <GroupsOutlined /> Customers
        </li>
        <li
          className="footer-links"
          onClick={
            store.attendant?.see_sales_details || store.mode === "Admin"
              ? () => navigate("/receipts")
              : noPrivy
          }
        >
          <ReceiptOutlined /> Receipts
        </li>
        <li
          className="footer-links"
          onClick={
            store.attendant?.see_sales_details || store.mode === "Admin"
              ? () => navigate("/expenses")
              : noPrivy
          }
        >
          <ShoppingCartCheckout /> Expenses
        </li>
        <Link to="/credit" className="footer-links">
          <AddCardOutlined /> Credit
        </Link>
        <Link to="/upload_data" className="footer-links">
          <ImportExport /> Import/Export Data
        </Link>
        <li
          onClick={
            store?.mode === "Admin" ? () => navigate("/attendants") : noPrivy
          }
          className="footer-links"
        >
          <PersonAddAltOutlined /> Attendants
        </li>
        <li
          onClick={
            store?.mode === "Admin" ? () => setOpenResetDialog(true) : noPrivy
          }
          className="footer-links"
        >
          <ResetTv /> Reset Store
        </li>
        <li
          className="footer-links"
          onClick={() => window.open("https://www.mycashlens.com", "_blank")}
        >
          <ManageAccounts />
          cashlens
        </li>
      </div>
      <span className="ml10">
        webcrony online &copy;{new Date().getFullYear()}
      </span>
    </div>
  );
}
